import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {observable, computed, makeObservable} from 'mobx';
import _ from 'lodash';

import Truncate from 'fn-common-ui/modules/truncate';

@observer
export class FAQ extends React.Component {
  static propTypes = {
    faqData: PropTypes.object,
    userRolesArray: PropTypes.array
  }

  static defaultProps = {
    userRolesArray: []
  }

  constructor(props) {
    super(props);
    makeObservable(this);
    this.faq = this.props.faqData;
    this.rolesToCheck = this.props.userRolesArray.filter(role => role !== 'G_FN');
  }

  componentWillUnmount() {
    this.activeCategory = 'All';
  }

  @observable activeCategory = 'All';
  @computed get categoriesToShow() {
    return this.faq.categories.filter(category => {
      return _.difference(this.rolesToCheck, category.hideFromRoles).length > 0;
    });
  }
  @computed get entriesToShow() {
    return this.faq.entries.filter(faq => {
      const titlesToShow = this.categoriesToShow.map(category => category.title);
      return titlesToShow.indexOf(faq.category) > -1;
    });
  }
  @computed get activeEntries() {
    if (this.activeCategory === 'All') {
      return this.entriesToShow;
    } else {
      return this.entriesToShow.filter(faq => faq.category === this.activeCategory);
    }
  }

  updateCategory = (event) => {
    event.preventDefault();
    this.activeCategory = event.target.value;
  }

  renderSingleButton = (category) => {
    const isActive = this.activeCategory === category.title;
    return (<button role="button" value={category.title} onClick={this.updateCategory} className={`as-link category-tab-button ${isActive
        ? 'active'
        : ''}`}>
        {category.title}<span className="sr-only"> FAQ category.</span>
    </button>)
  }

  renderCategoriesAsButtons = (categories) => {
    return (<div className="faq-category-tabs">
      <ul>
        {
          categories.map(category => {
            return (<li key={category.title}>
              {this.renderSingleButton(category)}
            </li>)
          })
        }
      </ul>
    </div>)
  }

  renderCategoriesAsSelectMenu = (categories) => {
    return (<div className="faq-category-select">
      <form>
        <label htmlFor="faqCategory">Filter By Category</label>
        <select id="faqCategory" className="form-control" onChange={this.updateCategory} value={this.activeCategory}>
          <option
            aria-label="All FAQ Categories"
            value="All">
            All Categories
          </option>
          {
            categories.map((category, i) => {
              return (
                <option
                  key={i}
                  value={category.title}>
                  {category.title}
                </option>
              )
            })
          }
        </select>
      </form>
    </div>)
  }

  renderFaqEntriesList = () => {
    return (<div className="faq-entry-list">
      {
        this.activeEntries.map((entry, i) => {
          return (<article key={entry.question} className="faq-entry">
            <h3 id={'faq-' + i}>{entry.question}</h3>
            <Truncate className="faq-entry-content" charLimit={entry.maxStringLength}>
              {entry.answer}
            </Truncate>
          </article>)
        })
      }
    </div>)
  }

  render() {
    return (
      <section className="container faq-section">
        <div className="row faq-filters">
          <div className="col-12 col-sm-10 offset-sm-1">
            <div className="d-none d-sm-block">
              {this.renderCategoriesAsButtons(this.categoriesToShow)}
            </div>
            <div className="d-block d-sm-none">
              {this.renderCategoriesAsSelectMenu(this.categoriesToShow)}
            </div>
          </div>
        </div>
        <div className="row faq-list">
          <div className="col-12 col-sm-10 offset-sm-1">
            <div className="horizontal-line-header">
              <h2>
                {this.activeCategory}
              </h2>
            </div>
            {this.renderFaqEntriesList()}
          </div>
        </div>
      </section>
    );
  }
}
